import request from '@/util/http'
import qs from 'qs'

// 服务列表查询
export const getServePage=(params)=>request({
    url: '/admin/serve/page',
    method: 'get',
    params
})

// 服务单个删除
export const handleServeDelete=(id)=>request({
    url: `/admin/serve/delete/${id}`,
    method: 'delete'
})
// 服务详情
export const getServeInfo=(id)=>request({
    url: `/admin/serve/get/${id}`,
    method: 'get'
})

// 保存服务
export const hallSaveOrUpdate=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: '/admin/serve/saveOrUpdate',
    method: 'post',
    data:JSON.stringify(data)
})
// 启用禁用
export const useOrDisuse=(params)=>request({
    url: '/admin/serve/useOrDisuse',
    method: 'post',
    params
})
